import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import header from '@/components/header'
import course from '@/components/course'
import more from '@/components/course_more'
import details from '@/components/details'
import pay from '@/components/pay'
import cp_pay from '@/components/cp_pay'
import zx_pay from '@/components/zx_pay'
import pay_success from '@/components/pay_success'
import course_system from '@/components/course_system'
import course_system1 from '@/components/course_system1'
import reading from '@/components/reading/reading'
import read_details from '@/components/reading/read_details'
import login from '@/components/popup/login'
import topic from "@/components/jytd/topic"
import evaluation1 from "@/components/cptx/evaluation"
import advisory from "@/components/zixun/advisory"
import live from '@/components/ketang/live'
import contact from '@/components/contact/contact'
import topic_details from '@/components/jytd/topic_details'
import evalu_more from '@/components/cptx/evalu_more'
import evalu_details from '@/components/cptx/evalu_details'
import evalu_ceping from '@/components/cptx/evalu_ceping'
import evalu_success from '@/components/cptx/evalu_success'
import evalu_result from '@/components/cptx/evalu_result'
import advi_details from '@/components/zixun/advi_details'
import xy from "@/components/xy"
import payGateWay from "@/components/payGateWay"
import huodong from "@/components/huodong"


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/huodong', name: 'huodong', component: huodong, meta: { title: '活动-文章', loAuth: false }, },
    { path: '/', name: 'index', component: index, meta: { title: '上海知会教育科技中心', loAuth: false } },
    { path: '/header', name: 'header', component: header },
    { path: '/course', name: 'course', component: course, meta: { title: '课程体系', loAuth: false }, },
    { path: '/more', name: 'more', component: more, meta: { title: '课程体系-更多', loAuth: false }, },
    { path: '/details', name: 'details', component: details, meta: { title: '课程详情', loAuth: false }, },
    { path: '/pay', name: 'pay', component: pay, meta: { title: '支付', loAuth: true }, },
    { path: '/cp_pay', name: 'cp_pay', component: cp_pay, meta: { title: '测评支付', loAuth: true }, },
    { path: '/zx_pay', name: 'zx_pay', component: zx_pay, meta: { title: '咨询支付', loAuth: true }, },
    { path: '/pay_success', name: 'pay_success', component: pay_success, meta: { title: '支付成功', loAuth: true }, },
    { path: '/course_system', name: 'course_system', component: course_system, meta: { title: '课程体系-详情-上课', loAuth: true }, },
    { path: '/course_system1', name: 'course_system1', component: course_system1, meta: { title: '课程体系-详情-上课', loAuth: true }, },
    { path: '/reading', name: 'reading', component: reading, meta: { title: '主题阅读', loAuth: false }, },
    { path: '/read_details', name: 'read_details', component: read_details, meta: { title: '主题阅读-详情', loAuth: false }, },
    { path: '/topic', name: 'topic', component: topic, meta: { title: '教研团队', loAuth: false }, },
    { path: '/topic_details', name: 'topic_details', component: topic_details, meta: { title: '教研团队-讲师详情', loAuth: false }, },
    { path: '/evaluation1', name: 'evaluation1', component: evaluation1, meta: { title: '评测体系', loAuth: false }, },
    { path: '/evalu_more', name: 'evalu_more', component: evalu_more, meta: { title: '评测体系-更多', loAuth: false }, },
    { path: '/evalu_details', name: 'evalu_details', component: evalu_details, meta: { title: '评测体系-详情', loAuth: false }, },
    { path: '/evalu_ceping', name: 'evalu_ceping', component: evalu_ceping, meta: { title: '评测体系-测评中', loAuth: true }, },
    { path: '/evalu_success', name: 'evalu_success', component: evalu_success, meta: { title: '评测体系-完成', loAuth: true }, },
    { path: '/evalu_result', name: 'evalu_result', component: evalu_result, meta: { title: '评测体系-结果', loAuth: true }, },
    { path: '/advisory', name: 'advisory', component: advisory, meta: { title: '咨询', loAuth: false }, },
    { path: '/advi_details', name: 'advi_details', component: advi_details, meta: { title: '咨询-详情', loAuth: false }, },
    { path: '/live', name: 'live', component: live, meta: { title: '在线课堂', loAuth: false }, },
    { path: '/contact', name: 'contact', component: contact, meta: { title: '联系我们', loAuth: false }, },
    { path: '/xy', name: 'xy', component: xy, meta: { title: '协议', loAuth: false }, },
    { path: '/payGateWay', name: 'payGateWay', component: payGateWay, meta: { title: '支付宝', loAuth: true }, },
    { path: '/login', name: 'login', component: login,meta: { title: '登录', loAuth: true },  },  
    {
      path: '/mine',
      name: 'mine',
      component: () => import('../view/mine/index'),
      children: [{
        path: '/mine',
        name: 'grzx',
        meta: { title: '个人中心', loAuth: true },
        component: () => import('../view/mine/grzx'),
      }, {
        path: '/mine/money',
        name: 'money',
        meta: { title: '个人中心-我的钱包', loAuth: true },
        component: () => import('../view/mine/money'),
      }, {
        path: '/mine/team',
        name: 'team',
        meta: { title: '个人中心-我的团队', loAuth: true },
        component: () => import('../view/mine/team'),
      }, {
        path: '/mine/curriculum',
        name: 'curriculum',
        meta: { title: '个人中心-我的课程', loAuth: true },
        component: () => import('../view/mine/curriculum'),
      }, {
        path: '/mine/evaluation',
        name: 'evaluation',
        meta: { title: '个人中心-我的测评', loAuth: true },
        component: () => import('../view/mine/evaluation'),
      }, {
        path: '/mine/consultation',
        name: 'consultation',
        meta: { title: '个人中心-我的咨询', loAuth: true },
        component: () => import('../view/mine/consultation'),
      }, {
        path: '/mine/collection',
        name: 'collection',
        meta: { title: '个人中心-课程收藏', loAuth: true },
        component: () => import('../view/mine/collection'),
      }, {
        path: '/mine/record',
        name: 'record',
        meta: { title: '个人中心-课程观看记录', loAuth: true },
        component: () => import('../view/mine/record'),
      }, {
        path: '/mine/news',
        name: 'news',
        meta: { title: '个人中心-我的消息', loAuth: true },
        component: () => import('../view/mine/news'),
      },
      {
        path: '/mine/system',
        name: 'system',
        meta: { title: '我的消息-系统消息', loAuth: true },
        component: () => import('../view/mine/system'),
      },
      {
        path: '/mine/activity',
        name: 'activity',
        meta: { title: '我的消息-系统消息', loAuth: true },
        component: () => import('../view/mine/activity'),
      },
      {
        path: '/mine/haibao',
        name: 'haibao',
        meta: { title: '我的消息-我的海报', loAuth: true },
        component: () => import('../view/mine/haibao'),
      }]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js